import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from "./store/index";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;
    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }
    return goTo(scrollTo);
  },
  routes: [
    {
      path: "/",
      redirect: "inicio",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "Inicio",
          path: "inicio",
          component: () => import("@/components/Monitor/Monitores"),
        },
        {
          name: "Clientes",
          path: "clientes",
          component: () => import("@/components/Cliente/Client"),
        },
        {
          name: "ClienteNuevo",
          path: "clientes/nuevo",
          component: () => import("@/components/Cliente/ClienteDetalle"),
        },
        {
          name: "ClienteDetalle",
          path: "clientes/:id",
          component: () => import("@/components/Cliente/ClienteDetalle"),
        },
        {
          name: "Prospectos",
          path: "prospectos",
          component: () => import("@/components/Prospectos/Prospectos"),
        },
        {
          name: "Polizas",
          path: "polizas",
          component: () => import("@/components/Poliza/Polizas"),
        },
        {
          name: "PolizasProximas",
          path: "polizas/proximas",
          component: () => import("@/components/Poliza/PolizasProximas"),
        },
        {
          name: "Creditos",
          path: "creditos",
          component: () => import("@/components/Credito/Creditos"),
        },
        {
          name: "CreditosProximos",
          path: "creditos/proximos",
          component: () => import("@/components/Credito/CreditosProximos"),
        },
        {
          name: "Solicitudes",
          path: "solicitudes",
          component: () => import("@/components/Solicitud/Solicitudes"),
        },
        {
          name: "Documentos",
          path: "documentos",
          component: () => import("@/components/Documento/Nueva"),
        },
        {
          name: "Usuarios",
          path: "usuarios",
          component: () => import("@/components/Users/Usuario"),
        },
        {
          name: "Aseguradoras",
          path: "catalogos/aseguradoras",
          component: () => import("@/components/Catalogos/Aseguradoras"),
        },
        {
          name: "Asesores",
          path: "catalogos/asesores",
          component: () => import("@/components/Catalogos/Asesores"),
        },
        {
          name: "Instituciones",
          path: "catalogos/instituciones",
          component: () => import("@/components/Catalogos/Instituciones"),
        },
        {
          name: "TiposPoliza",
          path: "catalogos/tipos-poliza",
          component: () => import("@/components/Catalogos/TiposPoliza"),
        },
        {
          name: "TiposCredito",
          path: "catalogos/tipos-credito",
          component: () => import("@/components/Catalogos/TiposCredito"),
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/presentacion",
      name: "PresentacionComercial",
      component: () => import("@/components/Landing/PresentacionComercial"),
      meta: { requiresAuth: false },
    },
    {
      path: "/institucional",
      name: "PresentacionInstitucional",
      component: () => import("@/components/Landing/PresentacionInstitucional"),
      meta: { requiresAuth: false },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/layouts/full-layout/Login"),
    },
    {
      path: "*",
      component: () => import("@/layouts/full-layout/NotFound"),
      meta: { requiresAuth: false },
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  NProgress.start(800);
  store.commit("setRouterHistory", from);

  if (to.matched.some((record) => record.meta.requiresAdminAuth)) {
    if (store.getters.getInfoUser && store.getters.getInfoUser.admin) {
      next();
      return;
    }
    next("/");
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    store.commit("setRouteData", { requireAuth: true });
    if (store.getters.getLoginStatus) {
      next();
      return;
    }
    next("/login");
  } else {
    store.commit("setRouteData", { requireAuth: false });
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
